import { createBrowserRouter, Navigate, useRouteError, useSearchParams } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import UserCustomizations from "../Pages/Customizations/UserCustomizations";
import Report from "../Pages/Report/Report";

const RouteError = () => {
    const error = useRouteError();
    return (
        <div style={{ padding: 40 }}>
            <h1>Something went wrong</h1>
            <p>{error?.message || "Unexpected error occurred"}</p>
        </div>
    );
};

const router = createBrowserRouter([
    {
        path: "/incomestatement/:urlInfo/:authId/:menuId/:corpId/:showreport?/:rediskey?",
        element: <ProtectedRoute />,
        errorElement: <RouteError />,
        children: [
            {
                index: true,
                element: <Navigate to="customization" replace />,
            },
            {
                path: "customization",
                element: <UserCustomizations />,
            },
            {
                path: "report",
                element: <Report />,
            },
        ],
    },
]);

export default router;

